module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Low Limit (%)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "1"
    },
    model: {
      value: (_vm.form.lowLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lowLimit", $$v)
      },
      expression: "form.lowLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "High Limit (%)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.highLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "highLimit", $$v)
      },
      expression: "form.highLimit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "Valve Speed (% / Minute)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10"
    },
    model: {
      value: (_vm.form.valveSetSpeed),
      callback: function($$v) {
        _vm.$set(_vm.form, "valveSetSpeed", $$v)
      },
      expression: "form.valveSetSpeed"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Low Pressure Close"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.enabledCheckboxChange
    },
    model: {
      value: (_vm.form.lowPressureClose.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form.lowPressureClose, "enabled", $$v)
      },
      expression: "form.lowPressureClose.enabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Low Pressure Setpoint (PSI)"
    }
  }, [_c('el-input', {
    on: {
      "focus": _vm.lowPressureCloseSetPointFocus
    },
    model: {
      value: (_vm.form.lowPressureClose.setPoint),
      callback: function($$v) {
        _vm.$set(_vm.form.lowPressureClose, "setPoint", $$v)
      },
      expression: "form.lowPressureClose.setPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61043dc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Motor.vue
// module id = 1405
// module chunks = 1